import React, { FC, ReactNode } from "react";
import { Card, CardHeader, Collapse, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface SnowflakeConnectionFormInfoCardProps {
  title: ReactNode;
  description: ReactNode;
  isCollapsed: boolean;
  handleCollapse: () => void;
}

export const SnowflakeConnectionFormInfoCard: FC<
  SnowflakeConnectionFormInfoCardProps
> = ({ title, description, isCollapsed, handleCollapse }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        border: "none",
        bgcolor: "grey.100",
        p: 1,
        pb: isCollapsed ? 0 : 1,
      }}
    >
      <CardHeader
        title={title}
        avatar={
          <IconButton
            onClick={handleCollapse}
            size="small"
            sx={{
              transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
              transition: "transform 0.3s",
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        }
        sx={{ p: 0 }}
      />
      <Collapse in={!isCollapsed} sx={{ pt: 1 }}>
        {description}
      </Collapse>
    </Card>
  );
};
